import { useMemo, useRef } from "react";
import Draggable from 'react-draggable';
import _ from "lodash";

import { getLabel } from "../../tools/Dictionary";
import { MdMode, MdAdd, MdHome, MdOutlineForward, MdCheck } from "react-icons/md";
import { RiArrowGoBackLine } from "react-icons/ri";
import { PiPath } from "react-icons/pi";


const ProcessDesignerFlowChartEntry = (props) =>
{

  //Props
  //const IsDesktop = props.IsDesktop;
  const ReadOnly = props.ReadOnly;
  const Data = props.Data;
  //const Step = props.Step;
  const OnClickDetail = props.OnClickDetail;
  const OnClickAdd = props.OnClickAdd;
  //const OnClickCondition = props.OnClickCondition;
  //const OnUpdateStep = props.OnUpdateStep;
  const SetCurrentMoving = props.SetCurrentMoving;
  const CopyMode = props.CopyMode;
  const CopyData = props.CopyData;
  const CurrentLinking = props.CurrentLinking;
  const IsSelected = useMemo(() => {
    if (CopyData){
      return CopyData.findIndex(c => c == Data._id) > -1;
    }

    return false;
  }, [CopyData, Data._id]);
  const OnClickSelectCopy = props.OnClickSelectCopy;
  const NewCounter = props.NewCounter;
  const OnStartLink = props.OnStartLink;
  const OnRightClickContextStep = props.OnRightClickContextStep;
  //const CreateCondition = props.CreateCondition;
  const OnUpdateGroup = props.OnUpdateGroup;

  //UseRef
  const hideLineAndCondition = useRef(false);



  const getNavigationButtonIcon = () =>
  {

    switch (Data.navigationButton)
    {
      case "Home":
        return <MdHome />
      case "Back":
        return <RiArrowGoBackLine />
      default:
        return <MdOutlineForward />;
    }

  };


  const onDragStart = (e, data) => {

    hideLineAndCondition.current = false;

  };

  const onDragOn = (e, data) => {

    if (hideLineAndCondition.current == false){

      // Get all div elements with the specified class
      let listArrow = document.querySelectorAll('line.processdesigner_flowchart_line');

      listArrow.forEach(line =>
      {
        if (line.id.includes(Data._id))
        {
          line.style.display = 'none';
        }

      });

      // Get all condition linked
      let listCondition = document.querySelectorAll('div.processdesigner_flow_conditon');

      listCondition.forEach(condition =>
      {
        if (condition.id.includes(Data._id))
        {
          condition.style.display = 'none';
        }

      });


      

    }

    hideLineAndCondition.current = true;

  };

  const onDragEnd = (e, data) => {
    
    
    const listArrow = document.querySelectorAll('line.processdesigner_flowchart_line');

    listArrow.forEach(line =>
    {
      if (line.id != "Linking_Line")
        line.style.display = 'block';
    });

    let listCondition = document.querySelectorAll('div.processdesigner_flow_conditon');
    
    listCondition.forEach(condition =>
    {

      condition.style.display = 'block';

    });

    let newPosition = {
      x: data.lastX < 0 ? 0 : data.lastX,
      y: data.lastY < 0 ? 0 : data.lastY
    }

    if (newPosition.x == Data.entry.position.x && newPosition.y == Data.entry.position.y) return;

    let updatedStep = _.cloneDeep(Data);

    updatedStep.position = newPosition;

    


    let closestGroup;
    let minDistance = Number.MAX_SAFE_INTEGER;

    if (!Data.isFirst){

      let currentNode = data.node.getBoundingClientRect();
      let listGroup = Array.from(document.querySelectorAll('.processdesigner_flow_group_cont'));

      listGroup.forEach(group =>
      {

        let groupRect = group.getBoundingClientRect();

        if (!(
          currentNode.right < groupRect.left ||
          currentNode.left > groupRect.right ||
          currentNode.bottom < groupRect.top ||
          currentNode.top > groupRect.bottom
        ))
        {

          let dx = currentNode.left - groupRect.left + (currentNode.width - groupRect.width) / 2;
          let dy = currentNode.top - groupRect.top + (currentNode.height - groupRect.height) / 2;
          let distance = Math.sqrt(dx * dx + dy * dy);

          // Check if closer
          if (distance < minDistance)
          {
            closestGroup = group;
            minDistance = distance;
          }

        }

      });

      if (closestGroup)
      {

        let currentId = closestGroup.id.substring(closestGroup.id.indexOf("_") + 1);

        updatedStep.parentGroup = currentId;

      }

    }


    let toUpdateGroup = _.cloneDeep(Data.group);

    let indexEntry = toUpdateGroup.entry.findIndex(s => s.processStep == Data.entry.processStep);

    toUpdateGroup.entry[indexEntry].position = newPosition;

    SetCurrentMoving(undefined)
    OnUpdateGroup(toUpdateGroup);

  };

  const handleClick = () => {

    // if (CurrentLinking.enabled && CurrentLinking.data._id != Data._id){


    //   CreateCondition(CurrentLinking.data, Data);
      
    // } else 
    
    if (CopyMode){

      OnClickSelectCopy(Data._id);

    }

  };



  return (
      <Draggable
        defaultPosition={{ x: Data.entry.position.x, y: Data.entry.position.y }}
        onStop={!ReadOnly && !CopyMode ? onDragEnd : undefined}
        onDrag={!ReadOnly && !CopyMode ? onDragOn : undefined}
        onStart={!ReadOnly && !CopyMode ? onDragStart : undefined}
        disabled={ReadOnly || CopyMode}
        bounds={{
          left: 0,
          top: 0,
          right: 5000,
          bottom: 20000
        }}
        grid={[10, 10]}

      >

      <div className={"processdesigner_flow_item_cont page_noselect " + (IsSelected ? "processdesigner_flow_item_cont_selected " : "") 
        + (NewCounter == Data.newCounter ? "processdesigner_flow_item_cont_new " : "")} 
        onContextMenu={(e) => OnRightClickContextStep(e, Data)}
        onClick={handleClick}
          >
      
        <div className="processdesigner_flow_item_header processdesigner_flow_item_header_entry" onDoubleClick={() => OnClickDetail(Data._id)} title={Data.title}>
            <div className="processdesigner_flow_item_header_col" style={{ fontSize: "12px", width: "75%" }}>
              {`${getLabel("ProcessDesigner", "Entry point")}`}
            </div>
            <div className="processdesigner_flow_item_header_col" title={getLabel("ProcessDesignerNavigationButton", Data.navigationButton)}>
              {getNavigationButtonIcon()}
            </div>
          </div>
          <div className="processdesigner_flow_item_title" onDoubleClick={() => OnClickDetail(Data._id)} title={Data.title}>
            <div className="processdesigner_flow_item_title_text">
            {Data.title}
            </div>
          </div>
          <div className="processdesigner_flow_item_footer">
            {CopyMode && IsSelected && !CurrentLinking.enabled &&
            <div className="processdesigner_selected_flow" title={getLabel("ProcessDesignerItem", "Edit")}
            >
              <MdCheck />
            </div>
            }
          {!CopyMode && !CurrentLinking.enabled &&
            <div className="page_button processdesigner_schema_add processdesigner_schema_add_entry" title={getLabel("ProcessDesignerItem", "Edit")}
              onClick={() => OnClickDetail(Data._id)}
            >
              <MdMode />
            </div>
            }
          {!ReadOnly && !CopyMode && !CurrentLinking.enabled &&
            <div className="page_button processdesigner_schema_add processdesigner_schema_add_entry" title={getLabel("ProcessDesigner", "Link with another step")}
              onClick={(e) => OnStartLink(e, Data)}
            >
              <PiPath />
            </div>
          }
          {!ReadOnly && !CopyMode && !CurrentLinking.enabled &&
            <div className="page_button processdesigner_schema_add processdesigner_schema_add_entry" title={getLabel("ProcessDesignerItem", "Add Step")}
                onClick={() => OnClickAdd(Data._id, Data.group._id)}
              >
                <MdAdd />
              </div>
            }
          </div>
        </div>
      </Draggable>
  );

}

export default ProcessDesignerFlowChartEntry;